// Room number to display name mapping - API/storage still uses numbers
export const getRoomDisplayName = (roomNumber: number): string => {
  const roomMap: { [key: number]: string } = {
    1: 'Root - WW',
    2: 'Mid - WW',
    3: 'Tip - WW',
    4: 'Root - SW',
    5: 'Mid - SW',
    6: 'Tip - SW',
    7: 'Root - LW',
    8: 'Mid - LW',
    9: 'Tip - LW',
    10: 'TE',
    11: 'LE'
  }
  return roomMap[roomNumber] || `Oda ${roomNumber}`
}

// Helper function to get month name in current language
export const getMonthName = (monthNumber: number, language: 'tr' | 'en'): string => {
  const monthsTr = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
    'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
  ]
  const monthsEn = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ]
  const months = language === 'tr' ? monthsTr : monthsEn
  return months[monthNumber - 1] || ''
}

// Maximum number of photos that can be uploaded in a single session
export const MAX_PHOTOS_PER_UPLOAD = 150
